import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { initializeConfiguration } from '../actions/app'
import { isActivelyPolling } from '../selectors/polling'
import UploadOptions from './UploadOptions'
import PollingOverlay from '../components/PollingOverlay'
import css from '../util/css'

import styles from './App.css'

export class App extends Component {
  constructor(props) {
    super(props)
    css.setTheme(props.theme)
  }
  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.props.initializeConfiguration()
    }
  }
  render() {
    const { polling, headingText, subheadingText } = this.props
    return (
      <div className={css.classNames(styles, 'wrapper')}>
        <PollingOverlay polling={polling}>
          <UploadOptions headingText={headingText} subheadingText={subheadingText} />
        </PollingOverlay>
      </div>
    )
  }
}

App.propTypes = {
  initializeConfiguration: PropTypes.func.isRequired,
  polling: PropTypes.bool.isRequired,
  headingText: PropTypes.string.isRequired,
  subheadingText: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  polling: isActivelyPolling(state),
  theme: state.theme,
})

const mapDispatchToProps = dispatch => ({
  initializeConfiguration: () => {
    dispatch(initializeConfiguration(false))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
